module.exports = __webpack_public_path__ + "img/img9.9f655bb2.jpg";